<template>
  <div class="novo-menu" id="scrollContainer">
    <div class="top-menu"  :id="switchShowMenu?'menu-height':'menu-height-zero'" >

      <Menu mode="horizontal" :active-name="topMenuAvtiveName" :theme="menutheme" @on-select="clickTopMenu">

        <MenuItem v-for="menuData  in menuDatas" v-if="menuData.url" :name='menuData.name' :to='menuData.url' :key="menuData.id">
          <router-link  :to="menuData.url" >
            {{menuData.text}}
          </router-link>
        </MenuItem>
        <li class="drop-down-box" v-else>
          <div class="qr-img-text" v-if="menuData.clickCallBack" @click="toNovoiot">{{menuData.text}}</div>
          <div class="qr-img-text"  v-else>{{menuData.text}}</div>
          <div v-if="menuData.slot" class="drop-down">
            <img class="qr-img" :src="PublicQR">
          </div>
        </li>

      </Menu>
      <div class="logo">
        <img class="logo-img" :src="logoUrl"/>
      </div>
    </div>

  </div>
</template>

<script>
  import {checkLS} from 'utils';
  import logoUrl from 'common/image/menu/logo.png';
  import PublicQR from 'common/image/menu/publicQR.png';
  import Bus from 'store/bus.js'

  export default {
    name: "NovoMenu",
    props: ['showMenu'],
    data() {
      return {
        logoUrl,PublicQR,
        switchShowMenu:true,
        userShow: false,
        tableData: [],
        columnsData: [
          {
            title: '授权模块',
            key: 'model'
          },
          {
            title: '授权时间',
            key: 'time'
          },
          {
            title: '管理数量',
            key: 'number'
          },
        ],
        menuDatas: [
          {
            name: "novoiot",
            text: "产品",
            url: "/home",
            id: 1,
          },
          {
            name: "device_manage",
            text: "解决方案",
            id: 2,
            url: "/solution",

          },
          // {
          //   name: "customer_case",
          //   text: "客户案例",
          //   url: "/customer_case",
          // },
          {
            name: "open_platform",
            text: "开放平台",
            url: "/open_platform",
          },
          {
            name: "acount_manage",
            text: "微信公众号",
            url: "",
            slot:'true'
          },
          {
            name: "contactus",
            text: "联系我们",
            url: "/contactus",
          },
          {
            name: "toNovoiot",
            text: "企业登录",
            clickCallBack : true
          },

        ],
        sideBarDatas: [],
        menutheme: "light",
        topMenuAvtiveName: "",
        activeName: ""
      };
    },
    mounted() {
      // chrome and ie
      window.addEventListener('mousewheel',this.handleScroll,false)
      // firefox
      window.addEventListener("DOMMouseScroll",this.handleScroll,false);
      window.addEventListener("scroll",this.scrollMove);
    },
    methods: {
      scrollMove(e){
        // console.log("-------")
        const top = document.body.scrollTop || document.documentElement.scrollTop
        if(top == 0 && this.switchShowMenu === false){
          this.switchShowMenu = true;
        }
      },
      handleScroll(e){
        // console.log("=====",e)
        if(e.deltaY){
          this.switchShowMenu = e.deltaY > -1 ?false:true;
        }else{
          if(e.wheelDelta){
            this.switchShowMenu= e.wheelDelta>-1?true:false;
          }else{
             this.switchShowMenu= e.detail<0?true:false;
          }

        }
      },
      showMenuMethod() {
        this.switchShowMenu = true;
      },
      clickTopMenu(name) {
        this.topMenuAvtiveName = name;
      },
      getAvtiveMenuName(){
        let nowUrl = this.$route.path;
        if(!nowUrl || nowUrl == '/'){
          nowUrl = '/home'
        }
        for(var i=0;i<this.menuDatas.length;i++){
          if(nowUrl === this.menuDatas[i].url){
            this.topMenuAvtiveName = this.menuDatas[i].name;
            return;
          }
        }
      },
      toNovoiot(){
        const local = window.location.host
        if (local.includes('novoiot.com')) {
          window.open("https://console.novoiot.com/login")
        } else if (local.includes('novoiot.cn')) {
          window.open("https://console.novoiot.cn/login")
        } else {
          window.open("https://console.novoiot.cn/login")
        }
      }
    },
    created () {
      this.getAvtiveMenuName();
    },
    beforeDestroy() {
      window.removeEventListener("mousewheel", this.handleScroll);
      window.removeEventListener("DOMMouseScroll", this.handleScroll);
      window.removeEventListener("scroll", this.handleScroll);
      // document.removeEventListener("scroll", this.scroll, false);

    },

    watch: {
      $route(to, from) {
        // 对路由变化作出响应...

      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .novo-menu {
    // height: 100%;
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;
    #menu-height-zero{
      overflow: hidden;
      // height:0;
      top: -80px;
      transition: top 500ms;
    }
    #menu-height{
      // overflow: hidden;
      top: 0px;
      transition: top 500ms;
    }
    .top-menu {
      position: fixed;
      width: 100%;
      height: 80px;
      z-index: 30;
      background: #fff;
      .logo{
        position: absolute;
        width: 230px;
        height: 80px;
        z-index:20;
        overflow: hidden;
        .logo-img{
          width:128px;
          margin:29px 0 0 60px;
        }
      }

      .ivu-menu-horizontal{
        z-index:10;
        position: absolute;
        height: 56px;
        width:100%;
        padding:10px 230px 0 230px;

        display: flex;
        justify-content: space-around;


        .drop-down-box{
          position: relative;
          text-align: center;
          cursor: pointer;
          .drop-down{
            display: none;
            width:124px;
            height: 136px;
            opacity: 0;
            position: absolute;
            left: 50%;
            transform: translate(-50%,0);
            transition: opacity 0.5s;

            .qr-img{
              width:124px;
              height: 136px;
            }
          }
          &:hover{
            .drop-down{
              opacity: 1;
              display: block;
              transition: opacity 0.5s;
            }

            &:after{
              content : '';
              position: absolute;
              background-image: linear-gradient(-135deg, #3CA9FF 0%, #7CE1FF 100%);
              top:54px;
              bottom: 0;
              left:0;
              width: 100%;
              height:2px;
              border-radius:12px;
            }
          }

          .qr-img-text{
            font-family: DFPKingGothicGB-Light;
            font-size: 14px;
            color: #000000;
            padding: 0 10px;

          }

        }
        .ivu-menu-item{
          padding:0;
          border:none;
          a {
            display: inline-block;
            text-align: center;
            height:56px;
            font-family: DFPKingGothicGB-Light;
            font-size: 14px;
            color: #000000;
            padding: 0 10px;
            display: block;
            height: 100%;
            width: 100%;
          }
        }
        .ivu-menu-item-active, .ivu-menu-item:hover, .ivu-menu-submenu-active,  .ivu-menu-submenu:hover{
         border:none;
         &:after{
          content : '';
          position: absolute;
          background-image: linear-gradient(-135deg, #3CA9FF 0%, #7CE1FF 100%);
          top:50px;
          bottom: 0;
          left:0;
          width: 100%;
          height:2px;
          border-radius:12px;
         }
        }
        .ivu-menu-submenu{
          color: #000000;
           .ivu-select-dropdown{
              padding:0 !important;
              margin:0 !important;
              color:red;
            }
          .ivu-menu-item-active, .ivu-menu-item:hover, .ivu-menu-submenu-active,  .ivu-menu-submenu:hover{
            &:after{
              content : '';
              width:0;
              height: 0;
            }
          }
        }


      }
      .ivu-menu-horizontal:after{
        content: '';
        display: none;
      }

    }

  }
</style>



// WEBPACK FOOTER //
// src/components/novo-menu.vue